import { featureKeys as dashboardFeatureKeys } from '@/api/callcenter/dashboard';
import queryClient from '@/lib/react-query';
import { ModelID } from '@/types';
import { post } from '@/utils/api';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AcceptedAssignment, featurePath } from '.';

// accept returns an envelope `{ data: <assignment> }`, so the shared post()
// helper's unconditional `body.data` unwrap resolves correctly here -- unlike
// heartbeat/feed-pause, there's no trap to work around.
export const postAcceptAssignment = (assignmentId: ModelID): Promise<AcceptedAssignment> =>
  post<AcceptedAssignment>(`${featurePath}/${assignmentId}/accept`, {}, undefined, {
    skipErrorToast: true,
  });

// Controller decision: no lead-detail cache warming here -- invalidating the
// dashboard query is the correctness mechanism. No toasts either: a 409 (lead
// rotated away) gets a friendly toast from the UI layer in a later task, and
// the raw server message must not double-toast alongside it.
export const useAcceptAssignment = () => {
  return useMutation<AcceptedAssignment, AxiosError, ModelID>({
    mutationFn: postAcceptAssignment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dashboardFeatureKeys.all });
    },
    onError: (error) => {
      // Server truth changed under us -- refresh the queue even though the
      // accept itself failed.
      if (error?.response?.status === 409) {
        queryClient.invalidateQueries({ queryKey: dashboardFeatureKeys.all });
      }
    },
  });
};
